import 'css-chunk:src/applications/ReportsApp/pages/Home/components/HomeLoading/HomeLoading.scss';export default {
  "ChartLoading": "_ChartLoading_1um7e_1",
  "TrendLoading": "_TrendLoading_1um7e_10",
  "AlertLoading": "_AlertLoading_1um7e_17",
  "ImpactLoading": "_ImpactLoading_1um7e_25",
  "label": "_label_1um7e_33"
};